import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDocumentFiling2Style0 = cosmosIconCss;

const CosmosIconDocumentFiling2$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDocumentFiling2 extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '259b916972788199646483becc3901ac75498103', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3e1bcc9d6177aa8df8ee06c4c706bb073c23420e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1dfb1c228114cabf83e92090e12db5b58cd20ef6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m13.285 4.68-2 2.15a.4.4 0 0 1-.57 0l-2-2.15a.4.4 0 0 1 .27-.68h1.25V1.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5V4h1.25a.4.4 0 0 1 .3.68ZM8.032 9.5a.5.5 0 0 1-.384-.18L5.298 6.5H3.5v5.75h15V6.5h-1.797l-2.35 2.82a.5.5 0 0 1-.385.18H8.032ZM20 12.75V5.5a.5.5 0 0 0-.5-.5h-3.266a.5.5 0 0 0-.384.18L13.5 8h-5L6.15 5.18A.5.5 0 0 0 5.766 5H2.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-7.75Zm-1.5 1h-1.797l-2.35 2.82a.5.5 0 0 1-.385.18H8.032a.5.5 0 0 1-.384-.18l-2.35-2.82H3.5v5.75h15v-5.75Zm-11.25 0 1.25 1.5h5l1.25-1.5h-7.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconDocumentFiling2Style0; }
}, [1, "cosmos-icon-document-filing-2", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-document-filing-2"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-document-filing-2":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDocumentFiling2$1);
            }
            break;
    } });
}

const CosmosIconDocumentFiling2 = CosmosIconDocumentFiling2$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDocumentFiling2, defineCustomElement };
